import { RFXRequest, RFXRevisionedId } from '../../interfaces/RFXBackendModel';
import { UIInput } from '../../types/uiTypes';
import { putRFXRequestMutation } from '../mutations/putRFXRequestMutation';

export interface PutRFXRequestInput extends UIInput {
  rfxRequest: RFXRequest;
}

export interface PutRFXRequestOutput {
  rfxRequestRevisionedId: RFXRevisionedId;
  rfxRequestVersion: number;
}

export async function putRFXRequest({ apolloClient, rfxRequest }: PutRFXRequestInput): Promise<PutRFXRequestOutput> {
  const response = await apolloClient.mutate({
    mutation: putRFXRequestMutation,
    variables: { rfxRequest }
  });

  return response.data.putRFXRequest as PutRFXRequestOutput;
}
